import React from 'react';
import { Navigate } from 'react-router-dom';
import './login.scss';
import Footer from '../Footer/footer';
import BasicHeader from '../basicHeader/basicHeader';
import login, { auth as AuthObject } from '../../services/login'
import cookie from '../../cookieHelper/cookie';
import getRecruiterInfo from '../../services/getRecruiterInfo';
import toastNotify from '../../utils/toastNotifier';
import withRouter from '../withRouter'
import { HOME_ROUTE } from '../../models/routes';
class Login extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            email: '',
            password: '',
            redirectToReferrer: false
        }

        this.checkAuth();   //// to check if user was already logged in 
    }

    checkAuth = () => {
        // console.log("CHECK AUTH RAN");
        console.log(this.props)
        AuthObject.authenticate(() => {
            // console.log("inside auth method");

            if (cookie.getCookie(process.env.REACT_APP_COOKIE_NAME)) {
                // console.log("cookie found");
                // this.state.redirectToReferrer = true
                AuthObject.isAuthenticated = true;
            }
        })
    }

    loginCheck = async (e) => {

        e.preventDefault();
        const data = {
            email: this.state.email,
            password: this.state.password
        }

        // this.validate();
        var ans = this.validate();


        if (ans == true) {

            try {
                var value = await login(data);
                // console.log("cookeVAlue: ", value)                
                if(value.status.code == '10200'){
                    var cookieName = process.env.REACT_APP_COOKIE_NAME;
                    cookie.setCookie(cookieName, value.data.token, 1);
                    var value = await getRecruiterInfo();
                    AuthObject.isAuthenticated = true;
                    this.setState({ redirectToReferrer: true });
                } else {
                    toastNotify(3, value.status.message)
                }
                
            }
            catch (err) {                
                toastNotify(3, "Login failed")
            }
            // console.log("authobject: ",AuthObject.isAuthenticated);

        }
        else {
            console.log("Not Logged in");
        }

    }
    validate() {
        var e = document.getElementById("emai").value;
        var p = document.getElementById("pswd").value;
        var atposition = e.indexOf("@");
        var dotposition = e.lastIndexOf(".");


        if (e.length == "") {
            document.getElementById("ema").innerHTML = "Please fill the email field";

            return false;
        }
        else if (atposition < 1 || dotposition < atposition + 2 || dotposition + 2 >= e.length) {

            document.getElementById("ema").innerHTML = "Incorrect Email";
            return false;
        }
        else if (p.length == "") {
            document.getElementById("pass").innerHTML = "Please fill the password field";

            return false;
        }
        else if (p.length < 4) {
            document.getElementById("pass").innerHTML = "Minimum 8 characters";

            return false;
        }
        else {
            return true;
            // this.submitForm();
        }
    }
    // setRedirect = () => {
    //     this.setState({
    //         redirect: true
    //     })
    // }
    // renderRedirect = () => {
    //     if (this.state.redirect) {
    //         return <Redirect to='/storyListing' />
    //     }
    // }

    // submitForm = async ()=>{
    //     try{
    //         var value = await login(data);
    //         var cookieName = process.env.REACT_APP_INC_HOST.toUpperCase() + "_CK1"
    //         cookie.setCookie(cookieName, value.data.en_cookie, 1);
    //         this.setState({ redirect: true });
    //         AuthObject.isAuthenticated = true;
    //     }
    //     catch(err){
    //         console.log("Login failed");
    //         var finalLoginMessage = document.getElementById('finalLoginMessage');
    //         finalLoginMessage.innerHTML = "Login failed"
    //     }
    // }

    render() {

        const from = this.props.location.state?.from || HOME_ROUTE;

        if (AuthObject.isAuthenticated) {
            // console.log("ELSE REDIRECT RAN");

            // return <Redirect to={'/storyListing'} />
            return <Navigate to={from} />

        }
        // else if (this.state.redirectToReferrer) {
        //     console.log("IF REDIRECT RAN");
        //     console.log("x");

        //     return <Redirect to={'/storyListing'} />
        // }

        return (
            <div>

                <BasicHeader />
                <form onSubmit={this.loginCheck}>
                    <section className="login_header">

                        <div className="wrapper">
                            <h1> Login </h1>
                            <div className="box-design">
                                <div className="form-group">
                                    <label>Email ID:</label>
                                    <input type="email" id="emai" className="form_input ele_spacing1 emailInput" placeholder="Enter Email"
                                        value={this.state.email}
                                        onChange={e => this.setState({ email: e.target.value })} />
                                    <div id="ema">
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Password:</label>
                                    <input type="password" id="pswd" className="form_input ele_spacing2 passwordInput" placeholder="Enter Password"
                                        value={this.state.password}
                                        onChange={e => this.setState({ password: e.target.value })} />
                                    <div id="pass"></div>
                                </div>

                                <button type="submit" className="btn-default submitButton">Login</button>
                                <p id="finalLoginMessage"></p>
                            </div>
                        </div>
                    </section>

                </form>
                <Footer />
            </div>
        );
    }
}

export default withRouter(Login);    